export const setCached = ({ cache, item, label }) =>
  !cache.getItem(label) && cache.setItem(label, item);
